import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const EditPencilIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.5637 4.47537L19.4847 8.39635M17.227 2.81206C17.747 2.29211 18.4522 2 19.1875 2C19.9229 2 20.6281 2.29211 21.148 2.81206C21.668 3.33201 21.9601 4.03722 21.9601 4.77255C21.9601 5.50787 21.668 6.21308 21.148 6.73304L5.88106 22H2V18.0391L17.227 2.81206Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

EditPencilIcon.displayName = 'EditPencilIcon';
